import QRCode from "qrcode";

export const textToLink = (text: string) => {
    
    const regexpForUrl = /(https?:\/\/[\w/:%#$&?()~.=+-]+)/g;
    
    const linkedText = text.replace(regexpForUrl, "<a href='$1' target='_blank' rel='noopener noreferrer'>$1</a>");

    return linkedText;
};

const linkFromText = (text: string): string[] => {
    const regexpForUrl = /(https?:\/\/[\w/:%#$&?()~.=+-]+)/g;

    return text.match(regexpForUrl)?.map(url => url.toString()) ?? [];
};

export const setQRListFromText = (text: string, setter: (value: string[]) => void) => {
    const linkList = linkFromText(text);
    const qrListPromise = Promise.all(linkList.map(link => QRCode.toDataURL(link)));
    qrListPromise.then(qrList => setter(qrList));
};
